<template>
  <div>
    <nav
      :class="[{'is-active': scrollTop > 50}]"
      aria-label="main navigation"
      class="navbar bg-navbar navbar-main bg-health"
      role="navigation">
        <div class="navbar-brand">
          <a href="/" exact class="navbar-item none-hover logo-item">
              <img src="@/assets/images/logos/logo.png" alt="" class="main-logo">
          </a>

          <div class="group-sp">
            <fragment v-if="!isLoggedIn">

              <router-link :to="'/signup'" class="navbar-item is-secondary modal-trigger">
                <span class="button signup-button rounded dowload-btn w180 raised">ĐĂNG KÝ DÙNG THỬ</span>
              </router-link>
            </fragment>
          </div>
          <a
            role="button"
            class="navbar-burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbar-menu"
            @click="toggleHamburger"
            :class="[{'is-active' :isOpenHamburger}]"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div id="navbar-menu" class="navbar-menu is-static" :class="[{'is-active' :isOpenHamburger}]">
          <div class="navbar-end" v-if="!isPartyLoggedIn">
            <fragment v-if="!isLoggedIn">
              
              <router-link :to="'/login'" class="navbar-item">
                <span class="button signup-button rounded main-btn raised" @click="toggleHamburger">ĐĂNG NHẬP</span>
              </router-link>

              <router-link :to="'/signup'" class="navbar-item is-secondary modal-trigger">
                <span class="button signup-button rounded dowload-btn w180 raised" @click="toggleHamburger">ĐĂNG KÝ DÙNG THỬ</span>
              </router-link>
            </fragment>
            <div class="navbar-item has-dropdown" :class="{show: isShowedNav}" @mouseover="isShowedNav = true" v-else @mouseout="isShowedNav = false">
                <a class="navbar-link is-arrowless is-white">
                  {{username}}
                  <b-icon icon="caret-down" pack="fa" class="nav-arrow-down"></b-icon>
                </a>
                
                <div class="navbar-dropdown">
                  <a class="navbar-item has-text-black" @click="logOut">ĐĂNG XUẤT</a>
                  <router-link :to="'/profile'" class="navbar-item has-text-black"><span @click="toggleHamburger">THÔNG TIN TÀI KHOẢN</span></router-link>
                </div>
            </div>
            <router-link :to="'/admin'" class="navbar-item is-secondary" v-if="isLoggedIn&&getUserType===1"><span @click="toggleHamburger">Quản trị</span></router-link>
            <router-link :to="'/index'" class="navbar-item is-secondary" v-if="isLoggedIn"><span @click="toggleHamburger">Trang chủ</span></router-link>
          </div>
        </div>
    </nav>
  </div>
</template>

<script>
import Utils from "./Utils";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    Fragment: () => import("vue-fragment").then(({ Fragment }) => Fragment)
  },
  data() {
    return {
      isOpenHamburger: false,
      scrollTop: 0,
      appPath: "",
      isShowedNav: false
    };
  },
  created() {
    document.addEventListener("scroll", e => {
      this.scrollTop =
        e.target.documentElement.scrollTop || e.target.body.scrollTop;
    });
    if(navigator.platform.toUpperCase().indexOf('MAC')>=0) {
      this.appPath = "https://downloads.polycom.com/video/realpresence_desktop/RPDMac_3_10_0_71129.dmg"
    } else {
      this.appPath = "/files/RPDesktop_3_10_0_71107.exe"
    }
  },
  methods: {
    toggleSideBar() {
      const isOpenSideBar = Utils.toggleState(this.isOpenSideBar);
      this.$parent.$emit("toggleSideBar", isOpenSideBar);
    },
    toggleHamburger() {
      this.isOpenHamburger = Utils.toggleState(this.isOpenHamburger);
    },
    logOut() {
      this.toggleHamburger()
      this.$store.dispatch("auth/logOut").then(() => {
        this.$router.go("/login");
      });
    }
  },
  computed: {
    ...mapState("auth", ["username"]),
	...mapGetters("auth", ["getUserType"]),
    isLoggedIn: function() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    isPartyLoggedIn: function() {
      return this.$store.getters["authParticipant/isLoggedIn"];
    },
    checkOpenSideBar() {
      return this.isOpenSideBar;
    }
  },
  props: {
    isOpenSideBar: {
      type: Boolean
    }
  }
};
</script>

<style lang="scss" scope>
@import "@/assets/scss/partials/_colors.scss";
  .nav-top {
    height: 40px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 11;
    min-height: 40px;
    box-sizing: border-box;
    padding-top: 5px;


    &_small {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      // color: #0e71eb;
      font-size: 15px;
      a {
        color: #0e71eb
      }


      &_col {
        padding: 0 7px;
      }
    }
  }


  .navbar {

    &-brand {
      margin-left: 2.5%;

      .navbar-burger {
        color: $white;
      }
    }
  }
  
  @media screen and (min-width: 1024px) {
    .navbar-menu {
      margin-right: 2.5%;
    }
  }
  .none-hover:hover, .logo-item:focus {
    background: none !important;
  }

  a.navbar-item, .is-white, a.navbar-link {
    color: #fff;
  }
  .navbar-dropdown {
    background-color: #fff !important;
  }
  a.navbar-item:hover {
    background-color: #fafafa
  }

  a.navbar-item:focus, a.navbar-item:focus-within, a.navbar-item:hover, a.navbar-item.is-active, .navbar-link:focus, .navbar-link:focus-within, .navbar-link:hover, .navbar-link.is-active {
    background-color: transparent !important;
    opacity: 0.7;
  }

  .nav-arrow-down.icon {
    padding-left: 10px;
    color: $green;
    display: none;
  }

  @media screen and (min-width: 1024px) {
    .navbar-dropdown {
      background-color: #00abe9;
    }

    .nav-arrow-down.icon {
      display: block;
    }
  }

  @media screen and (min-width: 1024px) {
    .navbar-item.has-dropdown:focus .navbar-link, .navbar-item.has-dropdown:hover .navbar-link, .navbar-item.has-dropdown.is-active .navbar-link {
      background-color: transparent !important;;
    }
  }

  @media (max-width: 1024px) {
    a.navbar-item, .is-white, a.navbar-link {
      color: #000 !important;
    }
    a.navbar-item:focus, a.navbar-item:focus-within, a.navbar-item:hover, a.navbar-item.is-active, .navbar-link:focus, .navbar-link:focus-within, .navbar-link:hover, .navbar-link.is-active {
        color: #000 !important;
        opacity: 0.7;
    }


  }

  .group-sp {
    display: none !important;
  }

  @media (max-width: 900px) {
    .nav-top { 
      &_small {
        font-size: 12px;
      }

    }
  }
  @media (max-width: 768px) {
    .group-sp {
      display: flex !important;
      margin-left: 10px;
      .navbar-item, .navbar-link {
        padding: 0
      }
      .button.signup-button {
        font-size: 0.7rem;
        font-weight: 600;
        padding: 4px 10px;
        width: auto;
        // background-color: transparent !important;
        border-color:  transparent !important;
      }
    }
    .hide-mobile {
      display: none;
    }
    .nav-top { 
      &_small {
        font-size: 11px;
      }

    }

    #prices {
      .row {
        flex-wrap: wrap
      }
      .column {
        flex-basis: 48%;
      }
    }
  }

  .show {
    .navbar-dropdown {
      display: block;
    }
  }

  .main-logo {
    vertical-align: middle;
  }

</style>